/*eslint-disable*/
import moment from 'moment';
import processFlowServices from '@/Services/Analytics Services/process-flow.services';
import storeServices from '@/Services/Form Services/store.services';
import shiftServices from '@/Services/shift.service';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import allVendorServices from '@/Services/Form Services/allvendor.services';

export const fieldApiMapping = {
	fromStore: {
		apiFunction: storeServices?.getStore,
		requestBuilder: (req) => ({
			id: '',
			type: 'BASE,WAREHOUSE_PRODUCT,WAREHOUSE,WAREHOUSE_INGREDIENT,RETAIL',
		}),
		responseTransform: (response) => {
			const storeList = response?.data?.map((store) => ({
				label: store.name,
				value: store.id,
				type: store.type,
				...store,
			})) || [];
			return storeList.sort((a, b) => {
				if (a.type === 'BASE' && b.type !== 'BASE') return -1;
				if (a.type !== 'BASE' && b.type === 'BASE') return 1;
				return 0;
			});
		},
		listKey: 'storeList',
	},
	buyer: {
		apiFunction: allVendorServices?.listVendor,
		requestBuilder: (req) => ({
			type: 'BUYER',
		}),
		responseTransform: (response) => {
			return response?.data?.map((buyer) => ({
				label: buyer.name,
				value: buyer.id,
				children: buyer?.vendor_locations?.map((location) => ({
					label: location.name,
					value: location.id,
					...location
				})) || [],
				...buyer,
			})) || [];
		},
		listKey: 'buyerList',
	},
	internalProcess: {
		apiFunction: processFlowServices?.fetchNodes,
		requestBuilder: (state) => ({
			params: {
				storeId: state?.fromStore?.id || state?.fromStore,
			},
		}),
		responseTransform: (response) => {
			return response?.data?.nodes?.map((process) => ({
				label: `${process?.data?.heading} (Section: ${process?.data?.sectionName ?? ''})`,
				value: process.id,
				...process,
			})) || [];
		},
		listKey: 'processList',
		dependsOn: ['fromStore'],
	},
	internalShift: {
		apiFunction: shiftServices.listProcessShifts,
		requestBuilder: (state) => {
			return ({
				data: {
					date: moment(new Date()).format('YYYY-MM-DD'),
					processIds: [state?.internalProcess?.id || state?.internalProcess],
					store: state?.fromStore?.id || state?.fromStore,
				},
			})
		},
		responseTransform: (response) => {
			return response?.data?.map((shift) => ({
				label: shift.shiftName,
				value: shift.id,
				...shift,
			})) || [];
		},
		listKey: 'shiftList',
		dependsOn: ['internalProcess'],
	},
	kitchen: {
		apiFunction: storeServices?.getStore,
		requestBuilder: (req) => ({
			id: '',
			type: 'BASE',
		}),
		responseTransform: (response) => {
			const storeList = response?.data?.map((store) => ({
				label: store.name,
				value: store.id,
				type: store.type,
				...store,
			})) || [];
			return storeList;
		},
		listKey: 'kitchenList',
	},
	shift: {
		apiFunction: inventoryAnalyticsServices.fetchShifts,
		requestBuilder: (state) => {
			return ({
				params: {
					storeId: state?.kitchen?.id || state?.kitchen,
				},
			})
		},
		responseTransform: (response) => {
			let list = response?.data?.map((shift) => ({
				label: shift.shiftName,
				value: shift.id,
				...shift,
			})) || [];
			// list.unshift({
			// 	label: 'All Shifts',
			// 	value: -999,
			// });
			return list;
		},
		listKey: 'shiftList',
		dependsOn: ['kitchen'],
	},
};
